module.exports = __webpack_public_path__ + "static/media/8OLA14.199a2b83.jpg";